import React from 'react';

const Decription = () => {
    return (
        <div className="decription">
            <h4>✨ QUI ĐỊNH ĐỔI HÀNG KHI MUA</h4>
            <p>- Mỗi hoá đơn chỉ được đổi một lần</p>
            <p>- Bạn có thể đổi hàng trong 14 ngày kể từ ngày mua hàng</p>
            <p>
                - Mặt hàng phải ở trong tình trạng ban đầu, còn nguyên tem mác, chưa qua sử dụng, chưa giặt giũ và có
                hoá đơn tương ứng
            </p>
            <p>
                - Bạn vui lòng giữ lại hoá đơn để được đổi hàng. Bạn có thể xuất trình hóa đơn mua hàng dưới dạng giấy
                in hoặc định dạng điện tử trên điện thoại di động của bạn
            </p>
            <p>
                - SSSTUTTER không áp dụng trả hàng - hoàn tiền dưới mọi hình thức (cả trong trường hợp hoá đơn đã mua có
                giá trị cao hơn hoá đơn đổi)
            </p>
            <p>
                - Với các sản phẩm giảm dưới 30%, SSSTUTTER sẽ hỗ trợ đổi hàng và số lượng sản phẩm đổi nhiều hơn sản
                phẩm trả, miễn tổng hoá đơn đổi bằng hoặc lớn hơn. Trong trường hợp hoá đơn đổi cao hơn, bạn vui lòng bù
                thêm phần chênh lệch.
            </p>
            <p>
                - Với các sản phẩm giảm dưới 30%, SSSTUTTER sẽ hỗ trợ đổi hàng và số lượng sản phẩm đổi nhiều hơn sản
                phẩm trả, miễn tổng hoá đơn đổi bằng hoặc lớn hơn. Trong trường hợp hoá đơn đổi cao hơn, bạn vui lòng bù
                thêm phần chênh lệch.
            </p>
            <p>- Với các sản phẩm giảm trên 30% và sản phẩm phụ kiện, SSSTUTTER sẽ không hỗ trợ đổi hàng,</p>
            <p>- Quà tặng không được đổi hoặc qui ra tiền, voucher.</p>
            <h4>✨ ĐẶC QUYỀN KHI MUA ĐỒ CỦA SSSTUTTER:</h4>
            <p>- Sản phẩm đúng với hình ảnh, thậm chí đẹp hơn trên hình, cả nam và nữ mặc lên đều phù hợp.</p>
            <p>
                - Bao bì nylon trắng đục có thể thấy được sản phẩm bên trong, tái chế chống mưa và hạn chế các tác động
                vật lý
            </p>
            <p>- Thiệp cám ơn, Card shop, hoá đơn mua hàng tiêu chuẩn chuyên nghiệp</p>
            <h4>✨ NHỮNG ĐIỀU LƯU Ý KHI BẢO QUẢN ÁO:</h4>
            <p>
                Không để áo ở các nơi ẩm và nên giặt áo ngay sau khi sử dụng để tránh ẩm mốc;
                <br /> Không giặt chung áo trắng với quần áo màu;
                <br />
                Không nên giặt trong nước nóng quá 40 độ để tránh áo bị giãn và mất form;
                <br /> Không đổ trực tiếp bột giặt lên quần áo khi giặt để tránh áo bị phai và loang màu;
                <br /> Không ngâm áo trong xà phòng quá lâu để tránh bạc màu.
            </p>
        </div>
    );
};

export default Decription;
